<template>
  <v-app
    v-if="tagsList.length"
    data-reviews-tags
  >
    <div
      class="text-body-1 text--text mb-2"
      data-qa="reviews_tags_title"
      :class="{ 'ml-2': isMobile }"
    >
      {{ t('Пациенты упоминали в отзывах', { ns: language }) }}
    </div>
    <div :class="{ 'px-2 pb-2 overflow-x-auto': isMobile }">
      <ReviewsTagsList
        :tags-list="tagsList"
        @change:tag="handleChangeTag"
      />
    </div>
  </v-app>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import I18NextVue from 'i18next'
import YaGoals from 'www/modules/YandexGoals'
import setQueryParam from 'www/utils/set/setQueryParam'
import deleteQueryParam from 'www/utils/delete/deleteQueryParam'
import dispatchCustomEventGlobally from 'www/utils/withDependences/dispatchCustomEventGlobally'
import type { Tag } from 'www/vue_components/common/ReviewsTags/types'
import ReviewsTagsList from 'www/vue_components/common/ReviewsTags/components/ReviewsTagsList.vue'

const props = withDefaults(defineProps<{
  tagsList?: Array<Tag>
  useRedirect: boolean
  redirectPathname: string
}>(), {
  tagsList: () => [],
  useRedirect: false,
  redirectPathname: '',
})

const { t, language } = I18NextVue
const isMobile = window.MOBILE_VERSION
const activeTag = ref(props.tagsList.find((tag: Tag) => tag.isActive))
const tagsList = props.useRedirect
  ? props.tagsList.map((tag: Tag) => {
    tag.isActive = false
    return tag
  })
  : props.tagsList
const yaGoalsInstance = new YaGoals()

function handleChangeTag(tag: Tag) {
  activeTag.value = tag

  if (props.redirectPathname && props.useRedirect) {
    if (tag.isActive) {
      setQueryParam('tag', tag.translit)
    } else {
      deleteQueryParam('tag')
      return
    }

    const { origin, search } = window.location
    const fullPath = `${origin}${props.redirectPathname}${search}#tab-content`

    yaGoalsInstance.send({ name: 'reviews_list_click_tag_lpu_redirect' })

    window.location.assign(fullPath)

    return
  }

  if (tag.isActive) {
    yaGoalsInstance.send({ name: 'reviews_list_click_tag_lpu' })
    setQueryParam('tag', tag.translit)
    dispatchCustomEventGlobally('change-query-tag', { tag: activeTag.value })
    return
  }

  deleteQueryParam('tag')
  dispatchCustomEventGlobally('change-query-tag', { tag: activeTag.value })
}

onMounted(() => {
  dispatchCustomEventGlobally('load-query-tag', { tag: activeTag.value })
})
</script>

<style lang="scss">
@import '~www/themes/doctors/common/mixins';

#app[data-reviews-tags] {
  @include v-app-reset;
}
</style>
